/* Eventually these strings should get moved to the components they're used in but creating generic file for now to kickoff translations */

import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	databaseTemplateType: {
		id: 'experiment-cfind-5291-template-touchpoint.database.template',
		defaultMessage: 'Database template',
		description:
			'Subheading text displayed below a template suggestion card to indicate this template is for creating a database content type.',
	},
	getStartedHeader: {
		id: 'experiment-cfind-5291-template-touchpoint.getting.started.header',
		defaultMessage: 'Get started',
		description:
			'Heading text displayed at the top of the onboarding takeover cards section to introduce the series of action cards that help users get started with Confluence.',
	},
	simpleRetrospectiveTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.simple.retrospective.template',
		defaultMessage: 'Simple retrospective',
		description:
			'Title of a whiteboard template for conducting a simple retrospective meeting to reflect on past work.',
	},
	flowchartTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.flowchart.template',
		defaultMessage: 'Flowchart',
		description:
			'Title of a whiteboard template for creating flowcharts to visualize processes and workflows.',
	},
	prioritizationMatrixTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.prioritization.matrix.template',
		defaultMessage: 'Prioritization matrix',
		description:
			'Title of a whiteboard template for creating a prioritization matrix to rank items by importance and effort.',
	},
	brainwritingTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.brainwriting.template',
		defaultMessage: 'Brainwriting',
		description:
			'Title of a whiteboard template for brainwriting sessions where team members write ideas silently.',
	},
	incidentPostmortemTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.incident.postmortem.template',
		defaultMessage: 'Incident postmortem',
		description:
			'Title of a whiteboard template for conducting incident postmortem reviews to analyze what went wrong and lessons learned.',
	},
	fourLsTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.four.ls.template',
		defaultMessage: '4 Ls Retro',
		description:
			'Title of a whiteboard template for a 4 Ls retrospective (Liked, Learned, Lacked, Longed for).',
	},
	networkOfTeamsTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.network.of.teams.template',
		defaultMessage: 'Network of teams',
		description:
			'Title of a whiteboard template for visualizing and organizing a network of teams.',
	},
	disruptiveBrainstormTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.disruptive.brainstorm.template',
		defaultMessage: 'Disruptive brainstorm',
		description:
			'Title of a whiteboard template for brainstorming sessions focused on disruptive ideas and innovation.',
	},
	conceptMapTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.concept.map.template',
		defaultMessage: 'Concept map',
		description:
			'Title of a whiteboard template for creating concept maps to visually represent relationships between ideas.',
	},
	swimlanesProcessMapTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.swimlanes.process.map.template',
		defaultMessage: 'Swimlanes process map',
		description:
			'Title of a whiteboard template for creating swimlane diagrams to map processes across departments or teams.',
	},
	swotAnalysisTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.swot.analysis.template',
		defaultMessage: 'SWOT Analysis',
		description:
			'Title of a whiteboard template for conducting SWOT analysis (Strengths, Weaknesses, Opportunities, Threats).',
	},
	focusAreaDiagramTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.focus.area.diagram.template',
		defaultMessage: 'Focus area diagram',
		description:
			'Title of a whiteboard template for creating focus area diagrams to identify and visualize key areas.',
	},
	userStoryMapTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.user.story.map.template',
		defaultMessage: 'User story map',
		description:
			'Title of a whiteboard template for creating user story maps to organize user journeys and workflows.',
	},
	fishboneDiagramTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.fishbone.diagram.template',
		defaultMessage: 'Fishbone diagram',
		description:
			'Title of a whiteboard template for creating fishbone diagrams to identify root causes of problems.',
	},
	orgChartTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.org.chart.template',
		defaultMessage: 'Org chart',
		description:
			'Title of a whiteboard template for creating organizational charts to visualize team structure.',
	},
	icebreakersTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.icebreakers.template',
		defaultMessage: 'Icebreakers',
		description:
			'Title of a whiteboard template for icebreaker activities to energize teams and build connections.',
	},
	serviceBlueprintTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.service.blueprint.template',
		defaultMessage: 'Service blueprint',
		description:
			'Title of a whiteboard template for creating service blueprints to visualize service design.',
	},
	productVisionTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.product.vision.board.template',
		defaultMessage: 'Product vision board',
		description:
			'Title of a whiteboard template for creating product vision boards to align team on product goals.',
	},
	workflowTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.workflow.template',
		defaultMessage: 'Workflow',
		description: 'Title of a whiteboard template for designing and visualizing workflows.',
	},
	timelineWorkflowTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.timeline.workflow.template',
		defaultMessage: 'Timeline workflow',
		description:
			'Title of a whiteboard template for creating timeline workflows to visualize processes over time.',
	},
	teamHealthMonitorTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.team.health.monitor.template',
		defaultMessage: 'Team health monitor',
		description: 'Title of a whiteboard template for monitoring team health and tracking metrics.',
	},
	teamCharterTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.team.charter.template',
		defaultMessage: 'Team charter template',
		description:
			'Title of a whiteboard template for creating team charters to define team purpose and values.',
	},
	actionPlanTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.action.plan.template',
		defaultMessage: 'Action plan',
		description:
			'Title of a whiteboard template for creating action plans to organize tasks and responsibilities.',
	},
	gapAnalysisTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.gap.analysis.template',
		defaultMessage: 'Gap analysis',
		description:
			'Title of a whiteboard template for conducting gap analysis to identify differences between current and desired states.',
	},
	productRoadmapTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.product.roadmap.template',
		defaultMessage: 'Product roadmap',
		description:
			'Title of a whiteboard template for creating product roadmaps to plan product development.',
	},
	crazy8sBrainstormingTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.product.crazy-8s-brainstorming.template',
		defaultMessage: 'Crazy 8s brainstorming',
		description:
			'Title of a whiteboard template for Crazy 8s brainstorming technique to generate multiple ideas rapidly.',
	},
	annualCalendarTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.product.annual-calendar.template',
		defaultMessage: 'Annual Calendar',
		description:
			'Title of a whiteboard template for planning annual calendars and organizing events.',
	},
	stakeholderMappingTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.product.stakeholder-mapping.template',
		defaultMessage: 'Stakeholder mapping',
		description:
			'Title of a whiteboard template for mapping stakeholders to understand relationships and influence.',
	},
	rootCauseTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.product.root-cause.template',
		defaultMessage: 'Root cause analysis',
		description:
			'Title of a whiteboard template for conducting root cause analysis to identify underlying causes of problems.',
	},
	executiveSummaryTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.product.executive-summary.template',
		defaultMessage: 'Executive summary',
		description:
			'Title of a whiteboard template for creating executive summaries of key information.',
	},
	elevatorPitchTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.product.elevator-pitch.template',
		defaultMessage: 'Elevator pitch',
		description:
			'Title of a whiteboard template for developing elevator pitches and brief communication points.',
	},
});
